import { z } from 'zod';
import type { GetEmbeddedCourseDto } from '../types/GetEmbeddedCourseDto';

export const getEmbeddedCourseDtoSchema = z.object({
  id: z.string().uuid(),
  title: z.string().min(3).max(255),
  description: z.string().min(3).max(255).nullable(),
  isPublic: z.boolean().default(true).optional(),
  isActive: z.boolean().default(false).optional(),
  cover: z.string().nullable(),
  creator: z.object({
    id: z.string().uuid(),
    firstName: z.string().min(2).max(64),
    lastName: z.string().min(2).max(64),
    avatar: z.string().nullable(),
    description: z.string().min(3).max(255).nullable(),
  }),
  cards: z.array(
    z.object({
      id: z.string().uuid(),
      type: z.enum([
        'video',
        'image',
        'text',
        'textAndImage',
        'quiz',
        'redirect',
      ]),
      title: z.string().min(3).max(255),
      isActive: z.boolean().default(false).optional(),
      content: z.string().nullable(),
      contentImage: z.string().nullable(),
      contentDetails: z.string().nullable(),
      position: z.number().int().min(1),
      creatorId: z.string().uuid(),
    }),
  ),
}) as z.ZodType<GetEmbeddedCourseDto>;
